// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CvKMjnJAU8yWDFiomh0s{color:var(--content-neutral-primary);display:flex}.zYA6FUplf6s1hNrezTrD{width:260px}.CTWhiLRMEs4DlfqfzCVK,.CHI0AmAo7OQ5cHtehvxy{line-height:14.52px}.CHI0AmAo7OQ5cHtehvxy{color:rgba(255,255,255,.7)}.crQqEr89qysZroFqKUVf{margin-top:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `CvKMjnJAU8yWDFiomh0s`,
	"wrap": `zYA6FUplf6s1hNrezTrD`,
	"label": `CTWhiLRMEs4DlfqfzCVK`,
	"desc": `CHI0AmAo7OQ5cHtehvxy`,
	"urlUpload": `crQqEr89qysZroFqKUVf`
};
export default ___CSS_LOADER_EXPORT___;
